import { createContext, useContext } from 'react';

export interface PublicConfig {
  googleVerificationCode: string;
  googleAnalyticsId: string;
  googleClientId: string;
}

export const PublicConfigContext = createContext<PublicConfig>({
  googleVerificationCode: '',
  googleAnalyticsId: '',
  googleClientId: '',
});

export function usePublicConfig() {
  return useContext(PublicConfigContext);
}
